import { bool, color, element, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { LegendsSize } from '../legends-constants.js';
const LegendItemProperties = {
    color: {
        type: color.group('style'),
    },
    hideLabel: {
        type: bool,
    },
    icon: {
        type: oneOfType([string, element]).group('style'),
    },
    label: {
        type: string,
    },
    notifyLegends: {
        defaultValue: true,
        type: bool.notEnumerable(),
    },
    size: {
        defaultValue: LegendsSize.NORMAL,
        type: oneOf(enumValues(LegendsSize)).group('style'),
    },
    value: {
        type: string,
    },
};
export { LegendItemProperties, };
//# sourceMappingURL=legend-item-types.js.map